// extracted by mini-css-extract-plugin
module.exports = {"spinnerOverlay":"spinner_spinnerOverlay__rbkXz","spinnerContainer":"spinner_spinnerContainer___GQr0","spin":"spinner_spin__i0tcF"};